<template>
	<div class="component upvote">
		<div class="uk-grid votes uk-grid-small">
			<div
				class="uk-width-auto uk-text-center up-vote"
				v-show="showUpVote"
			>
				<div class="uk-flex uk-flex-middle uk-flex-center">
					<span
						:class="{
							'uk-navbar-item uk-padding-xsmall': navBarItem,
						}"
					>
						<span
							class="icon material-symbols-outlined"
							:class="{
								active: currentUserVote == 1,
								pulse: pulseUp,
							}"
							@click="upVote(elementId, voteKey)"
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								height="24"
								viewBox="0 -960 960 960"
								width="24"
							>
								<path
									d="M440-320h80v-168l64 64 56-56-160-160-160 160 56 56 64-64v168Zm40 240q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
								/>
							</svg>
						</span>
						<span
							v-show="!hideTotalUp && showUpVote"
							class="total-up-votes"
						>
							{{ totalUpVotes }}
						</span>
					</span>
				</div>
			</div>
			<div
				class="uk-width-auto uk-text-center tally-vote"
				v-show="showTallyVote"
			>
				<div>{{ totalTallyVotes }}</div>
			</div>
			<div
				class="uk-width-auto uk-text-center down-vote"
				v-show="showDownVote"
			>
				<div class="uk-flex uk-flex-middle uk-flex-center">
					<span
						:class="{
							'uk-navbar-item uk-padding-xsmall': navBarItem,
						}"
					>
						<span
							class="icon material-symbols-outlined"
							:class="{
								active: currentUserVote == -1,
								pulse: pulseDown,
							}"
							@click="downVote(elementId, voteKey)"
							><svg
								xmlns="http://www.w3.org/2000/svg"
								height="24"
								viewBox="0 -960 960 960"
								width="24"
							>
								<path
									d="m480-320 160-160-56-56-64 64v-168h-80v168l-64-64-56 56 160 160Zm0 240q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
								/>
							</svg>
						</span>
						<span
							v-show="!hideTotalDown && showDownVote"
							class="total-down-votes"
						>
							{{ totalDownVotes }}
						</span>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	name: "upvote",
	props: {
		elementId: {
			type: Number,
			required: true,
		},
		voteKey: {
			type: String,
			default: null,
		},
		upVotes: {
			type: Number,
			default: null,
		},
		downVotes: {
			type: Number,
			default: null,
		},
		tallyVotes: {
			type: Number,
			default: null,
		},
		currentVote: {
			type: Number,
			default: null,
		},
		showUpVote: {
			type: Boolean,
			default: true,
		},
		showDownVote: {
			type: Boolean,
			default: true,
		},
		showTallyVote: {
			type: Boolean,
			default: true,
		},
		hideTotalUp: {
			type: Boolean,
			default: false,
		},
		hideTotalDown: {
			type: Boolean,
			default: false,
		},
		navBarItem: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			totalUpVotes: 0,
			totalDownVotes: 0,
			totalTallyVotes: 0,
			hasVoted: false,
			currentUserVote: undefined,
			pulseUp: false,
			pulseDown: false,
		};
	},
	computed: {
		downVotesTooltip() {
			return "Downvotes: " + this.totalDownVotes;
		},
		requireLogin() {
			return true;
		},
		isApp() {
			return this.$root.device.app;
		},
	},
	mounted() {
		var component = this;

		if (component.upVotes) {
			component.totalUpVotes = component.upVotes;
		}
		if (component.downVotes) {
			component.totalDownVotes = component.downVotes;
		}
		if (component.tallyVotes) {
			component.totalTallyVotes = component.tallyVotes;
		}
		if (component.currentVote) {
			component.currentUserVote = component.currentVote;
			component.hasVoted = true;
		}

		this.$logger(
			"app/components/upvote/mounted, elementId: " + component.elementId,
		);
	},
	methods: {
		upVote(elementId, voteKey) {
			this.$logger("app/components/upvote/upVote");
			var component = this;
			var app = this.$root;

			if (!elementId) {
				return;
			}

			if (component.requireLogin && !app.user.loggedIn) {
				app.$helper.loginRegisterModal({
					isApp: this.isApp,
				});
				return;
			}

			component.vote(elementId, voteKey, "upvote");
		},
		downVote(elementId, voteKey) {
			this.$logger("app/components/upvote/downVote");

			var app = this.$root;
			var component = this;

			if (!elementId) {
				return;
			}

			if (component.requireLogin && !app.user.loggedIn) {
				app.$helper.loginRegisterModal({
					isApp: this.isApp,
				});
				return;
			}

			component.vote(elementId, voteKey, "downvote");
		},
		vote(elementId, voteKey, type) {
			this.$logger("app/components/upvote/vote");

			var component = this;
			var app = this.$root;

			if (component.requireLogin && !app.user.loggedIn) {
				app.$helper.loginRegisterModal({
					isApp: this.isApp,
				});
				return;
			}

			if (
				component.hasVoted &&
				((type == "downvote" && component.currentUserVote == -1) ||
					(type == "upvote" && component.currentUserVote == 1))
			) {
				this.$logger("app/components/upvote/vote/already-voted");

				UIkit.notification({
					message: "Je hebt al gestemd!",
					status: "error",
					pos: "bottom-right",
					timeout: 3000,
				});

				return;
			}

			// Check for cookie
			var currentVotes = [];
			var vote = type == "upvote" ? 1 : -1;

			try {
				//currentVotes = JSON.parse(_helper.cookie.get("currentVotes"));
			} catch (e) {}

			if (currentVotes.length) {
				var elementExists = false;
				var voteExists = false;

				for (var i = 0; i < currentVotes.length; i++) {
					if (currentVotes[i].elementId == elementId) {
						elementExists = true;

						// Swap vote if it exists
						if (currentVotes[i].vote != vote) {
							currentVotes[i].vote = vote;
						} else {
							voteExists = true;
						}

						break;
					}
				}

				// Add new vote
				if (!elementExists && !voteExists) {
					currentVotes.push({
						elementId: elementId,
						vote: vote,
					});
				} else if (elementExists && !voteExists) {
					this.$logger("app/components/upvote/swap-vote/" + vote);
				} else {
					UIkit.notification({
						message:
							'<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM330-120 120-330v-300l210-210h300l210 210v300L630-120H330Zm34-80h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/></svg> Je hebt al gestemd',
						status: "error",
						pos: "bottom-right",
						timeout: 2000,
					});

					this.$logger("app/components/upvote/already-voted");
					return;
				}
			} else {
				currentVotes.push({
					elementId: elementId,
					vote: vote,
				});
			}

			// Reset pulse class
			component.pulseUp = false;
			component.pulseDown = false;

			//component.updateVoteTotals();

			// Set data
			var data = {
				id: elementId,
				key: voteKey,
			};

			// Append CSRF Token
			data[window.csrfTokenName] = window.csrfTokenValue;

			// Determine action url; should we swap votes or cast a new vote?
			var actionUrl = "/actions/upvote/vote/" + type;

			if (component.hasVoted) {
				actionUrl = "/actions/upvote/vote/swap";
			}

			// Request
			axios({
				method: "post",
				url: actionUrl,
				responseType: "json",
				data: data,
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					"Accept": "application/json",
				},
			})
			.then(function (response) {
				component.$logger(response);

				// Success
				var data = response.data;

				// Already voted
				if (data == "You have already voted on this element.") {
					UIkit.notification({
						message:
							'<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM330-120 120-330v-300l210-210h300l210 210v300L630-120H330Zm34-80h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/></svg> Je hebt al gestemd',
						status: "error",
						pos: "bottom-right",
						timeout: 3000,
					});

					// Voted
				} else {
					component.$logger(
						"app/components/upvote/vote/success: " + data.vote,
					);
					component.hasVoted = true;
					component.updateVoteTotals(data);
				}
			})
			.catch(function (error) {
				if (error) {
					console.error(error);
				}
			});
		},
		updateVoteTotals(data) {
			var component = this;

			component.$logger("app/components/upvote/vote/updateVoteTotals");

			component.currentUserVote = data.userVote;
			component.totalUpVotes = data.totalUpvotes;
			component.totalDownVotes = data.totalDownvotes;
			component.totalTallyvotes = data.tally;

			if (component.currentUserVote == 1) {
				component.pulseUp = true;
			} else {
				component.pulseDown = true;
			}
		},
	},
};
</script>

<style scoped>
.component.upvote {
	display: inline-block;
}
.component.upvote .icon:hover {
	color: var(--tint-color);
}
.component.upvote .icon:hover svg {
	fill: var(--tint-color);
}
.component.upvote .total-up-votes,
.component.upvote .total-down-votes {
	font-size: 1.2rem;
	vertical-align: middle;
	padding-left: 0px;
	padding-top: 3px;
}
.component.upvote .down-vote {
	padding-left: 6px;
}
</style>
